<div class="price-table-input-wrapper" [class.right-align]="rightAlign">
  <input
    *ngIf="property"
    matInput
    class="price-table-input"
    [class.invalid]="messages.length > 0"
    type="text"
    appNumberInput
    [localeCode]="languageCode"
    [numberOfDecimals]="property.MeasurementUnit?.Decimals"
    [numberFormControl]="control"
  />

  <!-- Error popup. Note that we use .hidden instead of *ngIf to keep a icon-sized space reserved -->
  <div
    class="icon-touch-target"
    [class.hidden-icon]="messages.length === 0"
    [matTooltip]="getValidationErrorText()"
    [matTooltipPosition]="rightAlign ? 'left' : 'right'"
  >
    <mat-icon class="ac-message-icon error" svgIcon="info" color="warn"></mat-icon>
  </div>
</div>
